import React, { useState, useEffect } from "react";
import ReactApexChart from "react-apexcharts";

const GlobalBasicBarChart = ({ seriesData }) => {
  const [chartData, setChartData] = useState({
    series: [
      {
        name: "Hombres",
        data: [seriesData.man],
      },
      {
        name: "Mujeres",
        data: [seriesData.woman],
      },
    ],
    options: {
      chart: {
        type: "bar",
        toolbar: {
          show: false, // Oculta la barra de herramientas, incluido el menú de descarga
        },
      },
      stroke: {
        show: true,
        colors: ['#fff'],
        width: 2,
      },
      plotOptions: {
        bar: {
          horizontal: true,
          barHeight: "90%",
        },
      },
      colors: ["#2563EB", "#DB2777"], // Azul para hombres, Rosa para mujeres
      dataLabels: {
        enabled: false,
        // DESCOMENTAR PARA MOSTRAR EL PORCENTAJE
        // formatter: function (val, opts) {
        //   const total = opts.w.globals.seriesTotals.reduce((a, b) => a + b, 0);
        //   const percent = Math.round((val / total) * 100);
        //   return percent + "%";
        // },
        // style: {
        //   fontSize: '14px',
        // }
      },
      xaxis: {
        categories: ["Género"],
        showAlways: false,
        opposite: true,
        show: false,
        labels: {
          show: false,
        },
        axisBorder: {
          show: false,
        },
        axisTicks: {
          show: false,
        },
      },
      yaxis: {
        showAlways: false,
        opposite: false,
        show: false,
        axisBorder: {
          show: false,
        },
        labels: {
          show: false,
        },
      },
      legend: {
        show: false,
      },
      grid: {
        show: false,
      },
    },
  });

  useEffect(() => {
    // if (seriesOrdersRes.seriesData && seriesOrdersRes.categories) {
    //   const filteredSeriesData = seriesOrdersRes.seriesData.filter((series) => {
    //     return series.data.some((value) => value !== 0);
    //   });

    setChartData((prev) => ({
      ...prev,
      series: [
        {
          name: "Hombres",
          data: [seriesData.man],
        },
        {
          name: "Mujeres",
          data: [seriesData.woman],
        },
      ],
    }));
  }, [seriesData]);

  return (
      <ReactApexChart
        options={chartData.options}
        series={chartData.series}
        type="bar"
        width={"100%"}
        height={120}
      />
  );
};

export default GlobalBasicBarChart;
